"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _reactSwipeableViewsUtils = require("react-swipeable-views-utils");

var _jsxRuntime = require("react/jsx-runtime");

var VirtualizeSwipeableViews = (0, _reactSwipeableViewsUtils.virtualize)(_reactSwipeableViews.default);

var Swiper = function Swiper(_ref) {
  var children = _ref.children,
      index = _ref.index,
      setIndex = _ref.setIndex;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(VirtualizeSwipeableViews, {
    axis: "x",
    index: index,
    resistance: true,
    animateHeight: true,
    overscanSlideCount: 1,
    overscanSlideAfter: 1,
    overscanSlideBefore: 1,
    ignoreNativeScroll: true,
    disableLazyLoading: false,
    animateTransitions: !isIE(),
    slideRenderer: function slideRenderer(_ref2) {
      var index = _ref2.index;
      return children[index];
    },
    slideCount: children.length,
    onChangeIndex: setIndex,
    id: 'swiper' + index
  });
};

var isIE = function isIE() {
  var ua = window.navigator.userAgent;
  var msie10 = ua.indexOf('MSIE');
  var msie11 = ua.indexOf('rv:11.0');

  if (msie10 > 0 || msie11 > 0) {
    // If Internet Explorer, return true
    return true;
  } // If another browser, return false
  else {
    return false;
  }
};

var _default = /*#__PURE__*/_react.default.memo(Swiper);

exports.default = _default;